import { ActionType } from '../../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { UserInfo } from '../../authState';


const KEY_ACTION = ActionType.LoginTalentSmartRequest;
const ACTIONS = [
  ActionType.LoginTalentSmartRequest,
  ActionType.LoginTalentSmartResponse,
  ActionType.LoginTalentSmartError,
];


type Payload = UserInfo;


type Meta = {
  auth: string;
};


/**
 * Dispatch this action to authenticate to the portal with user credentials
 * @param auth - an encrypted string containg email address and time stamp
 */
export const loginTalentSmartAction = (
  auth: string) => makeApiAction<Payload, Meta>({
    method: 'POST',
    endpoint: Endpoints.AuthenticateTalentSmart,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ auth: auth }),
    types: makeRsaaTypes<Payload, Meta>(ACTIONS, { auth: auth }),
    bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  const updatedUser = payload;
  updatedUser!.passwordUsed = updatedUser?.temporaryPasskey ?? ''; //TODO = pw handling for TSEQ?

  return R.assocPath([ 'auth', 'currentUser' ], updatedUser, successState);
};

export const loginTalentSmartReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);